import { render, staticRenderFns } from "./InputCnpj.vue?vue&type=template&id=c09bd4f8&scoped=true&"
import script from "./InputCnpj.vue?vue&type=script&lang=js&"
export * from "./InputCnpj.vue?vue&type=script&lang=js&"
import style0 from "./InputCnpj.vue?vue&type=style&index=0&id=c09bd4f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09bd4f8",
  null
  
)

export default component.exports